import React from "react";
import ShopsPage from "../shops";

export default function FavoriteShopsPage() {
    return <ShopsPage initialFilter="favorites" />;
}
